import { cn } from "~/lib/utils";

interface PanelSectionContentProps {
  children: React.ReactNode;
  className?: string;
}

export function PanelSectionContent({ children, className }: PanelSectionContentProps) {
  return <div className={cn("px-6 space-y-2", className)}>{children}</div>;
}
